import { AdminResourceEditor } from "./AdminResourceEditor";

const FIELDS = [
  { name: "title", label: "Title" },
  { name: "slug", label: "Slug (url-friendly, unique)" },
  { name: "excerpt", label: "Excerpt" },
  { name: "content", label: "Content", type: "textarea" },
  { name: "image", label: "Image", type: "image" },
  { name: "author", label: "Author" },
  { name: "category", label: "Category" },
];

const DEFAULTS = { title: "", slug: "", excerpt: "", content: "", image: "", author: "", category: "" };

export default function AdminBlog() {
  return (
    <AdminResourceEditor
      resourceLabel="Blog Post"
      apiPath="/admin/blog"
      fields={FIELDS}
      defaultValues={DEFAULTS}
      renderItem={(item) => (
        <>
          <p className="text-cream truncate">{item.title}</p>
          <p className="text-smoke text-xs mt-1">{item.author} &middot; {item.category}</p>
        </>
      )}
    />
  );
}
